<template>
  
    <section class="auth-page">
      <div class="animation-circle-inverse">
        <i></i>
        <i></i>
        <i></i>
      </div>
      <div class="animation-circle">
        <i></i>
        <i></i>
        <i></i>
      </div>
      <div class="container cooming-soon">
        <div class="row mb-50">
          <div class="col-md-6 left">
            <div class="clock-box">
              <div>
                <div class="mb-4">
                  <h2>We Are Launching Soon</h2>
                  <img
                    src="../assets/images/title-line.png"
                    alt=""
                    class="img-fluid"
                  />
                </div>
                <div id="clockdiv">
                  <div class="mr-2">
                    <span class="days">{{ days }}</span>
                    <div class="smalltext">Days</div>
                  </div>
                  <div class="mr-2">
                    <span class="hours">{{ hours }}</span>
                    <div class="smalltext">Hours</div>
                  </div>
                  <div class="mr-2">
                    <span class="minutes">{{ minutes }}</span>
                    <div class="smalltext">Minutes</div>
                  </div>
                  <div class="mr-2">
                    <span class="seconds">{{ seconds }}</span>
                    <div class="smalltext">Seconds</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="home-right">
              <div class="animation-circle-inverse">
                <i></i>
                <i></i>
                <i></i>
              </div>
              <div class="mobile-slid">
                <img
                  src="../assets/images/top-mobile.png"
                  alt="top1"
                  class="img-fluid"
                />
              </div>
              <div class="profile-msg">
                <img
                  src="../assets/images/top2.png"
                  alt="top2"
                  class="img-fluid"
                />
              </div>
              <div class="awesome">
                <img
                  src="../assets/images/top3.png"
                  alt="top3"
                  class="img-fluid"
                />
              </div>
              <div class="profile-1">
                <img
                  src="../assets/images/top4.png"
                  alt="top4"
                  class="img-fluid"
                />
              </div>
              <div class="emoji">
                <img
                  src="../assets/images/top5.png"
                  alt="top5"
                  class="img-fluid"
                />
              </div>
              <div class="profile-2">
                <img
                  src="../assets/images/top1.png"
                  alt="top1"
                  class="img-fluid"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="subscribe-bg">
      <div class="container">
        <div class="row">
          <div class="col-sm-12 col-lg-4">
            <div class="subscribe">
              <h3>Subscribe to Newsletter</h3>
            </div>
          </div>
          <div class="col-sm-12 col-lg-8">
            <div class="email-box">
              <form>
                <input
                  type="email"
                  class="form-control"
                  id="exampleInputEmail1"
                  placeholder="Enter your email"
                />
                <button type="submit" class="btn btn-email">Subscribe</button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>

    <Copyright />
  
</template>
<script>
import Copyright from "@/components/copy_right.vue";
export default {
  components:{
    Copyright
  },
  data() {
    return {
      td: 0,
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0,
      startTime: "",
      endTime: "",
    };
  },
  beforeCreate: function () {
    const path = this.$route.path; 
    if (path === "/chatloop/rtl/coming-soon") {
      document.body.className = "rtl";
    } else {
      document.body.className = "";
    }
  },
  mounted() {
    this.timer();
  },
  methods: {
    timer() {
      setInterval(() => {
        this.endTime = new Date().getTime();
        (this.startTime = new Date("Jan 9, 2025 00:00:00").getTime()),
          (this.td = this.endTime - this.startTime);
        if (this.td >= 0) {
          this.seconds = Math.floor((this.td / 1000) % 60);
          this.minutes = Math.floor((this.td / 1000 / 60) % 60);
          this.hours = Math.floor((this.td / (1000 * 60 * 60)) % 24);
          this.days = Math.floor(this.td / (1000 * 60 * 60 * 24));
        } else {
          this.seconds = this.minutes = this.hours = this.days = 0;
        }
      });
    },
  },
  beforeUnmount() {
    clearInterval(this.timer());
  },
};
</script>
